import styled from 'styled-components';
import Icon from 'gatsby-theme-core/src/components/form-elements/checkbox/icon';

export default styled(Icon)`
  border: 1px solid ${({ theme }) => theme.grayLightColor};
  background-color: ${({ theme }) => theme.backgroundColor};
  height: 1.25rem;
  width: 1.25rem;

  &:after {
    top: .2rem;
    left: .35rem;
  }
`;
